import clsx from 'clsx';

export type UnlabeledBulletColumnsData = Array<string | React.ReactNode>;

type Props = {
  data: UnlabeledBulletColumnsData;
  columnCount: number;
  columnWidth?: number | string;
  columnGap?: number | string;
  className?: {
    container?: string;
    itemContainer?: string;
    value?: string;
  };
  shouldBreakText?: boolean;
};

export default function UnlabeledBulletColumns({
  data,
  columnCount,
  columnWidth = '180px',
  columnGap = '2rem',
  className,
  shouldBreakText = false,
}: Props) {
  return (
    <ul
      className={clsx(className?.container ?? 'm-0 ps-5')}
      style={{
        columnCount: columnCount,
        columnWidth: columnWidth,
        columnGap: columnGap,
      }}
    >
      {data.map((value, index) => (
        <li className={clsx(className?.itemContainer)} key={index}>
          <span className={clsx(className?.value, shouldBreakText && 'text-break text-wrap')}>
            {value}
          </span>
        </li>
      ))}
    </ul>
  );
}
